import moment from 'moment'

export const DATE_PICKER_MIN_YEAR = 2018
export const DATE_PICKER_MAX_YEAR = moment().year() + 1
